import { IStorage } from '~/packages/core';

/**
 * Web implementation of IStorage using localStorage
 */
export class LocalStorageService implements IStorage {
    async get(key: string): Promise<string | null> {
        try {
            return localStorage.getItem(key);
        } catch (error) {
            // Handle cases where localStorage is not available (e.g., incognito mode)
            console.warn('localStorage.getItem failed:', error);
            return null;
        }
    }

    async getObject<T = any>(key: string): Promise<T | null> {
        try {
            const value = await this.get(key);
            if (value === null) {
                return null;
            }
            return JSON.parse(value) as T;
        } catch (error) {
            // Handle JSON parse errors
            console.warn('localStorage.getObject failed:', error);
            return null;
        }
    }

    async set(key: string, value: string): Promise<void> {
        try {
            localStorage.setItem(key, value);
        } catch (error) {
            // Handle cases where localStorage is not available or quota exceeded
            console.warn('localStorage.setItem failed:', error);
            // Don't throw - graceful degradation
        }
    }

    async setObject<T = any>(key: string, value: T): Promise<void> {
        try {
            const serializedValue = JSON.stringify(value);
            await this.set(key, serializedValue);
        } catch (error) {
            // Handle JSON stringify errors
            console.warn('localStorage.setObject failed:', error);
            // Don't throw - graceful degradation
        }
    }

    async remove(key: string): Promise<void> {
        try {
            localStorage.removeItem(key);
        } catch (error) {
            // Handle cases where localStorage is not available
            console.warn('localStorage.removeItem failed:', error);
            // Don't throw - graceful degradation
        }
    }
}
